import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import FilledInput from '@material-ui/core/FilledInput';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import Cookies from 'js-cookie';

import API_PATH from "../../constants/config.json";
import { setCookie } from '../../functions/Auth';
import { Container, CssBaseline } from '@material-ui/core';
import '../../scss/components/_user_details.scss';
import ErrorMessage from '../AppLayouts/ErrorMessage';

const axios = require('axios');
const API_URL = process.env.REACT_APP_BASE_URL;

const IOSSwitch = withStyles((theme) => ({
    root: {
      width: 42,
      height: 26,
      padding: 0,
      margin: theme.spacing(1),
    },
    switchBase: {
      padding: 1,
      '&$checked': {
        transform: 'translateX(16px)',
        color: theme.palette.common.white,
        '& + $track': {
          backgroundColor: '#52d869',
          opacity: 1,
          border: 'none',
        },
      },
      '&$focusVisible $thumb': {
        color: '#52d869',
        border: '6px solid #fff',
      },
    },
    thumb: {
      width: 24,
      height: 24,
    },
    track: {
      borderRadius: 26 / 2,
      border: `1px solid ${theme.palette.grey[400]}`,
      backgroundColor: theme.palette.grey[50],
      opacity: 1,
      transition: theme.transitions.create(['background-color', 'border']),
    },
    checked: {},
    focusVisible: {},
  }))(({ classes, ...props }) => {
    return (
      <Switch
        focusVisibleClassName={classes.focusVisible}
        disableRipple
        classes={{
          root: classes.root,
          switchBase: classes.switchBase,
          thumb: classes.thumb,
          track: classes.track,
          checked: classes.checked,
        }}
        {...props}
      />
    );
});

const UserDetails = (props) => {

    const [firstName, setFirstName] = React.useState('');
    const [lastName, setLastName] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [organization, setOrganization] = React.useState('');
    const [assignedTeams, setAssignedTeams] = React.useState([]);
    const [availableTeams, setAvailableTeams] = React.useState([]);
    const [teamsArray, setTeamsArray] = React.useState([]);

    const [errFirstName, setErrFirstName] = React.useState(null);
    const [errLastName, setErrLastName] = React.useState(null);

    const [initialFirstName, setInitialFirstName] = React.useState('');
    const [initialLastName, setInitialLastName] = React.useState('');
    const [initialOrganization, setInitialOrganization] = React.useState('');
    const [initialAssignedTeams, setInitialAssignedTeams] = React.useState([]);
    const [errMsgNotEmpty, setErrMsgNotEmpty] = useState(null);

    const [userStatus, setUserStatus] = useState(null);
    const [errPopUp, setErrPopUp] = React.useState(false);
    const [errMsg, setErrMsg] = React.useState(null);
    const [errMsgType, setErrMsgType] = React.useState('error');
    const [msgTitle, setMsgTitle] = useState(null);

    useEffect(
        () => {
          getUserDetails();
          if(props.needToReload)
            props.setNeedToReload(false);
        }, [props.needToReload]
    )

    const getUserDetails = () => {
        try {
          axios({
            method: 'post',
            data: {
              "userId": parseInt(sessionStorage.getItem('viewUserId')),
            },
            headers: {
              'payload': Cookies.get('payload'),
              'agencyid': sessionStorage.getItem('agency_id')
            },
            url: API_URL + API_PATH.getUserDetailsAPI,
          })
            .then(async function (response) {
              if (response.status && response.status == '200') {
                let arr = [];
                let fname = response.data.data.user_details.first_name;
                let lname = response.data.data.user_details.last_name;
                setFirstName(fname);
                setLastName(lname);
                setEmail(response.data.data.user_details.email);
                setOrganization(response.data.data.user_details.organization);
                setAssignedTeams(response.data.data.assigned_teams);
                let availableT = response.data.data.available_teams;
                response.data.data.assigned_teams.map((value, index) => {
                  arr.push(value.team.teams_id);
                  availableT.push(value.team);
                });
                setAvailableTeams(availableT);
                setTeamsArray(arr);
                setInitialFirstName(fname);
                setInitialLastName(lname);
                setInitialOrganization(response.data.data.user_details.organization);
                setInitialAssignedTeams(response.data.data.assigned_teams);
                if(response.data.data.assigned_teams.length > 0) {
                  setUserStatus('Active');
                } else {
                  setUserStatus('Disabled');
                }
                props.setActiveUsername(fname+" "+lname);
              } else {
                setFirstName('');
                setLastName('');
                setEmail('');
                setOrganization('');
                setTeamsArray([]);
              }
            })
            .catch(function (error) {
              if (error.response) {
                setFirstName('');
                setLastName('');
                setEmail('');
                setOrganization('');
                setTeamsArray([]);
              } else {
                setFirstName('');
                setLastName('');
                setEmail('');
                setOrganization('');
                setTeamsArray([]);
              }
            })
        } catch (error) {
          console.error(error);
        }
    }

    const handleChange = name => event => {
      let val = event.target.value;
        if (name == 'first_name') {
          setFirstName(val);
          if(val === '') {
            setErrFirstName(true);
            setErrMsgNotEmpty('Cannot be empty');
          } else {
            setErrFirstName(false);
          }
        } else if (name == 'last_name') {
          setLastName(val);
          if(val === '') {
            setErrLastName(true);
            setErrMsgNotEmpty('Cannot be empty');
          } else {
            setErrLastName(false);
          }
        } else if (name == 'organization') {
          setOrganization(val);
        }
    }

    const closeUserDetails = () => {
        props.setShowUserDetails(false);
    }

    const handleToggleGroup = (e,group_id) => {
      let tmpgroups = [...teamsArray];
      if(e.target.checked) {
        tmpgroups.push(group_id);
      } else {
        tmpgroups = tmpgroups.filter( item => item !== group_id);
      }
      setTeamsArray(tmpgroups);
    }

    const assignTeams = (e) => { // API call to assign team and update user profile
      props.setNeedToReload(false);
      setErrMsg(null)
      e.preventDefault();
      let data = { "teamId": teamsArray, "userId": parseInt(sessionStorage.getItem('viewUserId')), 'email': email, 'first_name': firstName, 'last_name': lastName, 'organization': organization }    
      try {
        axios({
          method: 'post',
          data: data,
          headers: {
            'payload': Cookies.get('payload'),
            'agencyid': sessionStorage.getItem('agency_id')
          },
          url: API_URL + API_PATH.assignTeamAPI,
        })
          .then(async function (response) {
            if (response.status && response.status == '200') {
              if(Cookies.get('email') === email) {
                setCookie('firstName', firstName);
                setCookie('lastName', lastName);
                setCookie('organization', organization && organization !== '' ? organization : '');
              }
              setErrMsgType('custom_success');
              setMsgTitle('Saved successfully');
              setErrMsg('--');
              setErrPopUp(true);
              if(initialAssignedTeams.length === 0 && teamsArray.length > 0 ) {
                setUserStatus('Active');
              } 
              props.setNeedToReload(true);
            } else {
              setErrMsgType('error')
              setErrMsg('Something went wrong.');
              setErrPopUp(true)
            }
          })
          .catch(function (error) {
            if (error.response) {
              setErrMsgType('error')
              setErrMsg(error.response.data.message);
              setErrPopUp(true)
            } else {
              setErrMsgType('error')
              setErrMsg('Something went wrong.');
              setErrPopUp(true)
            }
          })
      } catch (error) {
        console.error(error);
      }
    }

    const ShowErrPopUp = () => {
      setErrPopUp(false)
    };

    return (
        <React.Fragment>
            <CssBaseline />
            <div className="userdetails-main">
                <Container className="userdetails-container" maxWidth="lg">
                    <div>
                        <div className="details-top">
                            <div>
                                <p>
                                    <label className="section-title">User details</label>
                                    <label className={userStatus ? (userStatus === 'Active' ? "active-lbl" : "disabled-lbl") : ""}>{userStatus}</label>
                                </p>
                                <p className="section-description">Basic user information and assigned groups.</p>
                            </div>
                            <img src={require('../../assets/icons/close.svg')} onClick={closeUserDetails} />
                        </div>
                        <form className="root-form-details" noValidate autoComplete="off" onSubmit={e => assignTeams(e)}>
                            {errMsg ? <ErrorMessage message={errMsg} title={msgTitle} visible={ShowErrPopUp} show={errPopUp} msgType={errMsgType} /> : null}
                            <Grid container spacing={1} className="horizontal-divisor">
                                <Grid xs={6} item>
                                <Paper className="paper" >
                                    <p className="text-input-label">First Name</p>
                                    <FilledInput 
                                    id="first_name" 
                                    className={errFirstName ? "form-text-input-error" : "form-text-input"} 
                                    type="text" variant="outlined" required 
                                    value={firstName} 
                                    onChange={handleChange('first_name')}
                                    data-testid='first_name'  
                                    endAdornment={ errFirstName && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                    />
                                    {errFirstName ? <p className="form-error-label">{errMsgNotEmpty}</p> : null}
                                </Paper>
                                </Grid>
                                <Grid xs={6} item>
                                <Paper className="paper" >
                                    <p className="text-input-label">Last Name</p>
                                    <FilledInput 
                                    id="last_name" 
                                    className={errLastName ? "form-text-input-error" : "form-text-input"} 
                                    type="text" variant="outlined" required 
                                    value={lastName} 
                                    onChange={handleChange('last_name')}
                                    data-testid='last_name'  
                                    endAdornment={ errLastName && <FontAwesomeIcon icon={faExclamationCircle} className="end-error-icon" /> } 
                                    />
                                    {errLastName ? <p className="form-error-label">{errMsgNotEmpty}</p> : null}
                                </Paper>
                                </Grid>
                                <Grid xs={6} item>
                                <Paper className="paper" >
                                    <p className="text-input-label">Email</p>
                                    <FilledInput 
                                    id="email" 
                                    className="form-text-input"
                                    type="email" variant="outlined" 
                                    value={email}
                                    data-testid='email'  
                                    disabled={true}
                                    />
                                </Paper>
                                </Grid>
                                <Grid xs={6} item style={{position: 'relative'}}>
                                    <Paper className="paper" >
                                        <p className="text-input-label">Organization</p>
                                        <FilledInput 
                                        id="organization" 
                                        className="form-text-input" 
                                        type="text" variant="outlined"
                                        value={organization}
                                        onChange={handleChange('organization')}
                                        data-testid='organization'  
                                        />
                                    </Paper>
                                    <label className="optional-lbl">Optional</label>
                                </Grid>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper className="paper" >
                                <p className="section-title">Assigned groups</p>
                                <p className="section-description">Permission levels associates with this account</p>
                                    {
                                        availableTeams.map((value, index) => {
                                            return (
                                                <FormControlLabel
                                                    control={<IOSSwitch checked={teamsArray.indexOf(value.teams_id) >= 0} onChange={(e) => handleToggleGroup(e,value.teams_id)} />}
                                                    label={value.team_name}
                                                />
                                            )
                                        })
                                    }
                                </Paper>
                            </Grid>
                            <Grid item xs={12}>
                                <Paper className="buttons-cnt">
                                    <Button 
                                      className="disable-btn" 
                                      disabled={teamsArray.length > 0 ? false : true}
                                      onClick={() => props.handleShowDisableUser(true)}>
                                        Disable
                                    </Button>
                                    <div>
                                        <Button type="reset" variant="outlined" id="cancel_btn" className="cancel-btn" onClick={closeUserDetails}>
                                            Cancel</Button>&nbsp;&nbsp;
                                        <Button 
                                          type="submit" 
                                          variant="outlined" 
                                          id="save_btn" 
                                          className="blue-btn font-14"
                                          disabled={firstName === '' || lastName === '' ? true : false}
                                        >
                                            Save</Button>
                                    </div>
                                </Paper>
                            </Grid>
                        </form>
                    </div>
                </Container>
            </div>
        </React.Fragment>
    )
}

export default UserDetails;